import { Injectable, SimpleChange } from '@angular/core';
import { ObjectUtils } from './object-utils';

@Injectable()
export class SimpleChangesUtils {
    public static hasChanged(...changes: SimpleChange[]): boolean {
        return changes.some((value) => value && !ObjectUtils.isEqual(value.previousValue, value.currentValue));
    }
}
